// extracted by mini-css-extract-plugin
module.exports = {"title":"Detail_WhyChoosePlay_title__jqTLr","description":"Detail_WhyChoosePlay_description__D0CxR"};